import styled from 'styled-components';

const List = styled('ul')`
  display: grid;
  grid-template-columns: 1fr;

  > *[data-hide='true'] {
    height: 0;
    min-height: 0;
    margin-bottom: 0 !important;
  }
`;

export default List;
